import DrawerFilters, { DrawerFiltersList, useDrawerFilters } from "../../../../drawer-filters";
import { CustomFilters } from "../ProviderFilters/CustomFilters";

export default function DrawerFilterBtn() {
  const { filterState } = useDrawerFilters(CustomFilters);

  return (
    <DrawerFilters
      title="Filter"
      triggerId="provider-map-items-filters-button"
      closeButtonId="provider-map-filters-close-button"
    >
      <DrawerFiltersList filterState={filterState} options={{ replaceNavigation: false }} />
    </DrawerFilters>
  );
}
